<template>
  <div v-if="id && disabled && reasonsToDisableNewButton.length">
    <span :id="'disabled-wrapper-' + id" class="d-inline-block" tabindex="0">
      <b-button
        :id="id"
        :class="buttonClass"
        :disabled="disabled"
        @click="click"
        :type="typeButton"
      >
        <span class="container-button" :style="spanStyle">
          <slot name="icon" :size="18" />
          <slot />
        </span>
      </b-button>
    </span>
    <b-tooltip placement="bottom" :target="'disabled-wrapper-' + id"
      >Verifique os dados do emitente:
      <div v-for="(data, index) in reasonsToDisableNewButton" :key="index">
        - {{ data }}
      </div>
    </b-tooltip>
  </div>
  <button
    v-else
    class="btn"
    :id="id"
    :class="buttonClass"
    :disabled="disabled"
    :type="typeButton"
    @click="click"
  >
    <span class="container-button" :style="spanStyle">
      <slot name="icon" :size="18" />
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    id: {
      type: String,
      required: false,
    },
    tooltipText: {
      type: String,
      required: false,
    },
    reasonsToDisableNewButton: {
      type: Array,
      required: false,
    },
    type: {
      type: String,
      validator: () => [
        'default',
        'primary',
        'success',
        'warning',
        'error',
        'clean',
        'white',
      ],
      default: () => 'default',
    },
    outline: {
      type: Boolean,
      default: () => false,
    },
    rounded: {
      type: Boolean,
      default: () => false,
    },
    size: {
      type: String,
      validator: () => ['', 'small'],
      default: () => '',
    },
    labelSize: {
      type: String,
      validator: () => ['', 'small'],
      default: () => '',
    },
    align: {
      type: String,
      validator: () => ['left', 'center'],
      default: () => 'left',
    },
    upperCase: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    fullWidth: {
      type: Boolean,
      default: () => false,
    },
    submit: {
      type: Boolean,
      default: () => false,
    },
    location: {
      type: String,
      default: '',
    },
    icon: {},
  },
  data() {
    return {
      isIcon: false,
    };
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
  computed: {
    typeButton() {
      return this.submit ? 'submit' : 'button';
    },
    buttonClass() {
      const classType = {
        default: 'btn-default',
        primary: 'btn-primary',
        success: 'btn-success',
        error: 'btn-error',
        warning: 'btn-warning',
        clean: 'btn-clean',
        cancel: 'btn-cancel',
        white: 'btn-white',
      };
      return {
        [classType[this.type]]: true,
        upper: this.upperCase,
        [this.size]: true,
        'btn-outline': this.outline,
        'btn-rounded': this.rounded,
        'btn-full-width': this.fullWidth,
        'btn-center': this.align === 'center',
      };
    },
    spanStyle() {
      if (this.location === 'title' || this.labelSize === 'small') {
        const styles = ['font-size: 14px !important;'];
        return styles.join(' ');
      }

      return false;
    },
  },
};
</script>
